<template>
    <div class="qksm qksm9">
        <h4>九、其他重要事项的情况说明</h4>
        <p><b>（一）机关运行经费安排情况。</b></p>
        <div class="nogap">
            <p class="hide_pdf">
                选择单位性质：
                <reason type="select" classname="qksm select " name="单位类型" v-model:value="qksm['单位类型']" optionarr="事业单位,临时机构,行政单位（含参照公务员管理的事业单位）"></reason>
            </p>
            <p v-if="qksm['单位类型']=='事业单位'">{{$store.state.divData.divname}}所属预算单位全部为事业单位，无机关运行经费支出。</p>
            <p v-else-if="qksm['单位类型']=='临时机构'">{{$store.state.divData.divname}}所属预算单位为临时机构，无机关运行经费支出。</p>
            <p v-else>
                2022年{{$store.state.divData.divname}}机关运行经费财政拨款预算<reason type="money" classname="qksm money" name="机关运行经费" v-model:value="T6.机关运行经费"></reason>万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money nullable" name="机关运行经费_去年" v-model:value="T6.机关运行经费last"></reason>万元）
                </span>
                <span v-if="num(T6.机关运行经费)==num(T6.机关运行经费last)">
                    与上年相同。
                </span>
                <span v-else>
                    比上年预算{{growthValueText(num(T6.机关运行经费), num(T6.机关运行经费last))}}万元，
                    <span v-if="num(T6.机关运行经费)!= num(T6.机关运行经费last) &&  num(T6.机关运行经费last)==0">
                        去年无预算。主要是
                        <reason type="textarea" classname="qksm widest" name="原因_机关运行经费" v-model:value="qksm['原因_机关运行经费']"></reason>
                    </span>
                    <span v-else>
                        {{growthRatioText(num(T6.机关运行经费), num(T6.机关运行经费last))}}。主要是
                        <reason type="textarea" classname="qksm widest" name="原因_机关运行经费" v-model:value="qksm['原因_机关运行经费']"></reason>
                    </span>
                </span>
            </p>
        </div>

        <p><b>（二）政府采购安排情况。</b></p>
        <div class="nogap">
            <p>
                2022年{{$store.state.divData.divname}}各单位政府采购预算总额<reason type="money" classname="qksm money" name="政府采购总计" v-model:value="政府采购.政府采购总计"></reason>万元，
                其中：政府采购货物预算<reason type="money" classname="qksm money" name="政府采购货物类" v-model:value="政府采购.政府采购货物类"></reason>万元、
                政府采购工程预算<reason type="money" classname="qksm money" name="政府采购工程类" v-model:value="政府采购.政府采购工程类"></reason>万元、
                政府采购服务预算<reason type="money" classname="qksm money" name="政府采购服务类" v-model:value="政府采购.政府采购服务类"></reason>万元。
            </p>
        </div>

        <p><b>（三）国有资产占有使用情况。</b></p>
        <div class="nogap">
            <p>
                截至2021年12月底，{{$store.state.divData.divname}}所属各预算单位共有车辆<reason type="integer" classname="qksm integer" name="共有车辆" v-model:value="国有资产.共有车辆"></reason>辆，
                其中，省级领导干部用车<reason type="integer" classname="qksm integer" name="省级领导干部用车" v-model:value="国有资产.省级领导干部用车"></reason>辆、
                厅级领导干部用车<reason type="integer" classname="qksm integer" name="厅级领导干部用车" v-model:value="国有资产.厅级领导干部用车"></reason>辆、
                一般公务用车<reason type="integer" classname="qksm integer" name="一般公务用车" v-model:value="国有资产.一般公务用车"></reason>辆、
                一般执法执勤用车<reason type="integer" classname="qksm integer" name="一般执法执勤用车" v-model:value="国有资产.一般执法执勤用车"></reason>辆、
                特种专业技术用车<reason type="integer" classname="qksm integer" name="特种专业技术用车" v-model:value="国有资产.特种专业技术用车"></reason>辆、
                其他用车<reason type="integer" classname="qksm integer" name="其他用车" v-model:value="国有资产.其他用车"></reason>辆。
                单价50万元以上通用设备<reason type="integer" classname="qksm integer" name="五十万元以上通用设备" v-model:value="qksm['五十万元以上通用设备']"></reason>台（套），
                单价100万元以上专用设备<reason type="integer" classname="qksm integer" name="一百万元以上专用设备" v-model:value="qksm['一百万元以上专用设备']"></reason>台（套）。
            </p>
        </div>

        <p><b>（四）绩效目标设置情况。</b></p>
        <div class="nogap">
            <p>
                2022年{{$store.state.divData.divname}}预算均实行绩效目标管理，涉及项目<reason type="integer" classname="qksm integer" name="绩效项目" v-model:value="绩效目标.绩效项目"></reason>个，
                预算金额<reason type="money" classname="qksm money" name="绩效金额" v-model:value="绩效目标.绩效金额"></reason>万元。
            </p>
            <p class="hide_pdf upload" @click="uploadJx('jxmbb')">*若本单位涉及绩效目标管理，请务必上传部门预算项目支出绩效目标公开表【->点此前往】</p>
        </div>
    </div>
</template>

<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm9",
        components: {
            reason,
        },
        props: {
            T6: {
                type: Object,
                default: "",
            },
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (!qksm['单位类型']) {
                qksm['单位类型'] = '行政单位（含参照公务员管理的事业单位）'
            }
            if (qksm['机关运行经费']) {
                this.T6['机关运行经费'] = qksm['机关运行经费']
            }
            if (qksm['机关运行经费_去年']) {
                this.T6['机关运行经费last'] = qksm['机关运行经费_去年']
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                attachments: this.$store.state.divData.attachments,
                政府采购: {
                    政府采购总计: qksm['政府采购总计'],
                    政府采购货物类: qksm['政府采购货物类'],
                    政府采购工程类: qksm['政府采购工程类'],
                    政府采购服务类: qksm['政府采购服务类'],
                },
                国有资产: {
                    共有车辆: qksm['共有车辆'],
                    省级领导干部用车: qksm['省级领导干部用车'],
                    厅级领导干部用车: qksm['厅级领导干部用车'],
                    一般公务用车: qksm['一般公务用车'],
                    一般执法执勤用车: qksm['一般执法执勤用车'],
                    特种专业技术用车: qksm['特种专业技术用车'],
                    其他用车: qksm['其他用车'],
                },
                绩效目标: {
                    绩效项目: qksm['绩效项目'],
                    绩效金额: qksm['绩效金额'],
                }
            }
        },
        created() {
            this.zfcgInspect()
            this.gyzcInspect()
            this.jxmbInspect()
        },
        updated: function () {
            this.attachments = this.$store.state.divData.attachments
            this.zfcgInspect()
            this.gyzcInspect()
            this.jxmbInspect()
        },
        watch: {
            $route() {
                this.attachments = this.$store.state.divData.attachments
                this.zfcgInspect()
                this.gyzcInspect()
                this.jxmbInspect()
            },
        },
        methods: {
            uploadJx(name) {
                this.$router.push({ path: '/div/uploadPerform', query: { divid: this.$route.query.divid, tag: name }, });
            },
            zfcgInspect() {
                var arr = Object.values(this.政府采购)
                var sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm92", "请检查本页《九、（二）政府采购安排情况。》，各项政府采购预算总和应该等于政府采购预算总额。");
                } else {
                    this.remove("qksm92")
                }
            },
            gyzcInspect() {
                var arr = Object.values(this.国有资产)
                var sum = 0;
                for (var i = 1; i < arr.length; i++) {
                    sum = sum + this.num(arr[i])
                }
                if (this.num(arr[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm93", "请检查本页《九、（三）国有资产占有使用情况。》，各项车辆使用情况总和应该等于部门拥有车辆总数。");
                } else {
                    this.remove("qksm93")
                }
            },
            jxmbInspect(){
                if(this.num(this.绩效目标.绩效项目) > 0 && this.num(this.绩效目标.绩效金额) <= 0){
                    this.addOrSet("qksm94", "请检查本页《九、（四）绩效目标设置情况。》，涉及项目大于0时预算金额必须大于0。");
                }else{
                    this.remove("qksm94")
                }
                if(this.num(this.绩效目标.绩效金额) > 0 && this.attachments.filter(e => e.claims.tag == 'jxmbb').length == 0){
                    this.addOrSet("jx1", "请上传绩效目标表。");
                } else {
                    this.remove("jx1")
                }
            }
        }
    };
</script>

<style scoped>
    .upload {
        color: #9ECADF;
        font-weight: 600;
    }
</style>